/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

import { VueQueryPlugin } from "@tanstack/vue-query";

import * as axios from "axios";
// Composables
import { createApp } from "vue";

// Plugins
import { registerPlugins } from "@/plugins";

// Components
import App from "./App.vue";

import { currentAccount, localAccount } from "./authenticationTokens";

// Styles
import "unfonts.css";

axios.default.interceptors.request.use((config) => {
  if (!config.headers.Authorization) {
    const a = currentAccount.value;
    const l = localAccount.value;
    if (a && config.url?.startsWith("/repos/")) {
      config.baseURL = a.server + "/api/v1/";
      config.headers.Authorization = `token ${a.token}`;
    } else if (l && config.url?.startsWith("/v1/")) {
      config.baseURL = "/api";
      config.headers.Authorization = `bearer ${l.token}`;
    }
  }
  return config;
});

// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
const app = createApp(App);
app.use(VueQueryPlugin);
registerPlugins(app);

app.mount("#app");
